import { coreApi } from '.';
import { TAG_TYPES } from 'types/services';
import type { GoogleLoginResponse, MicrosoftLogin, MicrosoftLoginResponse, MicrosoftRedirectUri, MicrosoftRedirectUriResponse } from 'types';

export const loginService = coreApi.injectEndpoints({
  overrideExisting: true,
  endpoints: (builder) => ({
    // TODO: F20-3137 Remove after Keycloak login cutover (feature-flag rollout, then delete old OAuth).
    googleAuthorizeUri: builder.query<
      {
        authorizeUri: string;
      },
      { state: string }
    >({
      query: (data) => ({
        url: 'Auth/GoogleAuthorizeUri',
        method: 'GET',
        params: {
          State: data.state,
        },
      }),
    }),
    // TODO: F20-3137 Remove after Keycloak login cutover (feature-flag rollout, then delete old OAuth).
    googleLogin: builder.query<
      GoogleLoginResponse,
      {
        tokenId: string;
        authorizationCode: string;
      }
    >({
      query: (data) => ({
        url: 'Auth/LoginWithGoogle',
        method: 'POST',
        body: {
          TokenId: data.tokenId,
          AuthorizationCode: data.authorizationCode,
        },
      }),
      providesTags: (result) => (result ? [{ type: TAG_TYPES.LOGIN, id: 'Google' }] : []),
    }),
    // TODO: F20-3137 Remove after Keycloak login cutover (feature-flag rollout, then delete old OAuth).
    microsoftRedirectUri: builder.query<MicrosoftRedirectUriResponse, MicrosoftRedirectUri>({
      query: (data) => ({
        url: 'Auth/MicrosoftAuthorizeUri',
        method: 'GET',
        params: {
          PkceCodeVerifier: data.pkceCodeVerifier,
          State: data.state,
        },
      }),
      providesTags: (result) => (result ? [{ type: TAG_TYPES.LOGIN, id: 'Microsoft' }] : []),
    }),
    // TODO: F20-3137 Remove after Keycloak login cutover (feature-flag rollout, then delete old OAuth).
    microsoftLogin: builder.query<MicrosoftLoginResponse, MicrosoftLogin>({
      query: (data) => ({
        url: 'Auth/LoginWithMicrosoft',
        method: 'POST',
        body: data,
      }),
    }),

    refreshToken: builder.mutation<MicrosoftLoginResponse, null>({
      query: () => ({
        url: 'Auth/RefreshToken',
        method: 'PUT',
      }),
    }),
    refreshMobileToken: builder.mutation<MicrosoftLoginResponse, null>({
      query: () => ({
        url: 'Auth/MobileApp/RefreshToken',
        method: 'PUT',
      }),
    }),
  }),
});
export const {
  useLazyGoogleLoginQuery,
  useLazyMicrosoftRedirectUriQuery,
  useLazyMicrosoftLoginQuery,
  useLazyGoogleAuthorizeUriQuery,
  useRefreshTokenMutation,
  useRefreshMobileTokenMutation,
} = loginService;
